import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { apiUrl, imageUrl } from '../../Constants/contant';

function ServiceDetailsMain() {

    const { id } = useParams();

    const [servicePost, setService] = useState(null);
    const [allProducts, setAllProducts] = useState([]);
    const [activeImage, setActiveImage] = useState(null);

    // POPUP
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {

        if (!id) return;

        fetch(apiUrl + `product-details/${id}`)
            .then(response => response.json())
            .then(data => {

                const product = data?.product;
                const products = data?.allproduct || [];

                setService(product);
                setAllProducts(products);

                // DEFAULT IMAGE
                if (product?.image) {
                    setActiveImage(product.image);
                }
                else if (product?.images?.length > 0) {
                    setActiveImage(product.images[0]);
                }

            })
            .catch(error => {
                console.error("Error fetching product details:", error);
            });

    }, [id]);

    // IMAGE PATH
    const getImagePath = (img) => {

        if (!img) return '';

        // FULL URL
        if (img.startsWith('http')) {
            return img;
        }

        return `${imageUrl}/${img}`;
    };

    // LOADING
    if (!servicePost) {

        return (
            <div className="text-center py-5">
                Loading...
            </div>
        );

    }

    return (
        <>

            {/* CSS */}

            <style>

                {`

                    /* MAIN IMAGE */

                    .main-image {
                        overflow: hidden;
                        border-radius: 14px;
                        cursor: pointer;
                        background: #f5f5f5;
                        height: 100%;
                    }

                           .th-btn {
  background: #F8CE50 !important;
  color: #000 !important;
  border: 1px solid #F8CE50 !important;
}

.th-btn:hover {
  background: #000 !important;
  color: #fff !important;
  border: 1px solid #000 !important;
}

.th-btn::before,
.th-btn::after {
  display: none !important;
}

                    .main-image img {
                        width: 100%;
                        height: 550px;
                        object-fit: cover;
                        border-radius: 14px;
                    }

                    /* SIDE THUMBNAILS */

                    .side-thumbnail-wrapper {
                        display: flex;
                        flex-direction: column;
                        gap: 12px;
                    }

                    /* PRICE */

                    .service-price {
                        margin-bottom: 20px;
                    }

                    .price-label {
                        display: inline-block;
                        font-size: 14px;
                        font-weight: 500;
                        color: #161212;
                        margin-bottom: 5px;
                    }

                    /* TOUR ACTION */

.tour-action {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 15px;
    gap: 10px;
}

.tour-action span {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #555;
    font-weight: 500;
}

/* SMALL BUTTON */

.small-btn {
    padding: 10px 18px !important;
    font-size: 14px !important;
    border-radius: 8px !important;
    line-height: 1 !important;
}

                    .price-value {
                        font-size: 38px;
                        font-weight: 700;
                        color: #1d1b16;
                        margin: 0;
                        line-height: 1;
                    }

                    .side-thumbnail-image {
                        width: 100%;
                        height: 100px;
                        object-fit: cover;
                        border-radius: 10px;
                        cursor: pointer;
                        border: 2px solid #ddd;
                        transition: 0.3s;
                        background: #fff;
                    }

                    .side-thumbnail-image:hover {
                        transform: scale(1.03);
                    }

                    .side-thumbnail-image.active {
                        border-color: #ff681a;
                    }

                    /* CONTENT */

                    .service-content h2 {
                        font-size: 34px;
                        font-weight: 700;
                    }

                    .destination-text {
                        line-height: 1.9;
                        color: #555;
                    }

                    .rating-stars i {
                        font-size: 18px;
                        margin-right: 3px;
                    }

                    /* RELATED PRODUCTS */

                    .related-product-card {
                        border: 1px solid #eee;
                        border-radius: 14px;
                        overflow: hidden;
                        background: #fff;
                        transition: 0.3s;
                        height: 100%;
                    }

                    .related-product-card:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 10px 25px rgba(0,0,0,0.08);
                    }

                    .related-product-image {
                        overflow: hidden;
                        height: 250px;
                    }

                    .related-product-image img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transition: 0.4s;
                    }

                    .related-product-card:hover .related-product-image img {
                        transform: scale(1.08);
                    }

                    .related-product-content {
                        padding: 20px;
                    }

                    .related-product-content h5 {
                        font-size: 20px;
                        font-weight: 600;
                        margin-bottom: 10px;
                    }

                    /* IMAGE POPUP */

                    .image-popup-overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(0,0,0,0.9);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        z-index: 99999;
                        padding: 20px;
                    }

                    .image-popup-content {
                        position: relative;
                        max-width: 1000px;
                        width: 100%;
                        text-align: center;
                    }

                    .main-popup-image {
                        width: 100%;
                        max-height: 80vh;
                        object-fit: contain;
                        border-radius: 12px;
                        background: #fff;
                    }

                    .popup-close-btn {
                        position: absolute;
                        top: -15px;
                        right: -15px;
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        border: none;
                        background: #fff;
                        font-size: 22px;
                        font-weight: bold;
                        cursor: pointer;
                        z-index: 10;
                    }

                    /* POPUP GALLERY */

                    .popup-gallery {
                        display: flex;
                        gap: 12px;
                        flex-wrap: wrap;
                        justify-content: center;
                        margin-top: 20px;
                    }

                    .popup-gallery-image {
                        width: 90px;
                        height: 90px;
                        object-fit: cover;
                        border-radius: 10px;
                        cursor: pointer;
                        border: 2px solid transparent;
                        transition: 0.3s;
                        background: #fff;
                    }

                    .popup-gallery-image:hover {
                        transform: scale(1.05);
                    }

                    .popup-gallery-image.active {
                        border-color: #ff681a;
                    }

                    /* MOBILE */

                    @media (max-width: 768px) {

                        .main-image img {
                            height: 320px;
                        }

                        .side-thumbnail-wrapper {
                            flex-direction: row;
                            overflow-x: auto;
                            margin-top: 15px;
                        }

                        .side-thumbnail-image {
                            width: 70px;
                            min-width: 70px;
                            height: 70px;
                        }

                        .popup-gallery-image {
                            width: 70px;
                            height: 70px;
                        }

                    }

                `}

            </style>

            {/* MAIN SECTION */}

            <section className="space">

                <div className="container">

                    <div className="row g-5">

                        {/* LEFT SIDE */}

                        <div className="col-lg-6">

                            <div className="row">

                                {/* MAIN IMAGE */}

                                <div className="col-lg-10 col-md-10">

                                    {activeImage && (

                                        <div
                                            className="main-image"
                                            onClick={() => setShowPopup(true)}
                                        >

                                            <img
                                                src={getImagePath(activeImage)}
                                                alt={servicePost.name}
                                            />

                                        </div>

                                    )}

                                </div>

                                {/* SIDE IMAGES */}

                                <div className="col-lg-2 col-md-2">

                                    <div className="side-thumbnail-wrapper">

                                        {/* BANNER IMAGE */}

                                        {servicePost?.image && (

                                            <img
                                                src={getImagePath(servicePost.image)}
                                                alt="banner"
                                                className={`side-thumbnail-image ${
                                                    activeImage === servicePost.image
                                                        ? 'active'
                                                        : ''
                                                }`}
                                                onClick={() =>
                                                    setActiveImage(servicePost.image)
                                                }
                                            />

                                        )}

                                        {/* OTHER IMAGES */}

                                        {servicePost?.images?.map((img, index) => (

                                            <img
                                                key={index}
                                                src={getImagePath(img)}
                                                alt="thumbnail"
                                                className={`side-thumbnail-image ${
                                                    activeImage === img ? 'active' : ''
                                                }`}
                                                onClick={() => setActiveImage(img)}
                                            />

                                        ))}

                                    </div>

                                </div>

                            </div>

                        </div>

                        {/* RIGHT SIDE */}

                        <div className="col-lg-6">

                            <div className="service-content">

                                <h2 className="mb-3">
                                    {servicePost.name}
                                </h2>

                                {/* RATING */}

                                <div className="mb-3 rating-stars">

                                    {Array.from({ length: 5 }, (_, index) => {

                                        const rating = servicePost?.rating || 0;

                                        if (rating >= index + 1) {

                                            return (
                                                <i
                                                    key={index}
                                                    className="fa fa-star text-warning"
                                                ></i>
                                            );

                                        }
                                        else if (rating >= index + 0.5) {

                                            return (
                                                <i
                                                    key={index}
                                                    className="fa fa-star-half-alt text-warning"
                                                ></i>
                                            );

                                        }
                                        else {

                                            return (
                                                <i
                                                    key={index}
                                                    className="fa fa-star-o text-warning"
                                                ></i>
                                            );

                                        }

                                    })}

                                    <span className="ms-2">
                                        {servicePost?.rating || 0} Rating
                                    </span>

                                </div>

                                {/* DESCRIPTION */}

                                {/* PRICE */}


                                <p
                                    className="destination-text"
                                    dangerouslySetInnerHTML={{
                                        __html: servicePost.description,
                                    }}
                                    ></p>
                                
                                                {servicePost?.price && (
                                                    
                                                    <div className="service-price mt-3">

                                                        <span className="price-label">
                                                            Price
                                                        </span>

                                                        <h3 className="price-value">
                                                            ₹{servicePost.price}
                                                        </h3>

                                                    </div>

                                                )}

                                {/* BUTTON */}

                                <Link
                                    to="/contact"
                                    className="th-btn style mt-3"
                                >
                                    Book Now
                                </Link>

                            </div>

                        </div>

                    </div>

                </div>

            </section>

            {/* RELATED PRODUCTS */}

            <section className="pb-5">

                <div className="container">

                    <div className="row mb-4">

                        <div className="col-12">

                            <h2 className="fw-bold">
                                Related Products
                            </h2>

                        </div>

                    </div>

                    <div className="row g-4">

                        {allProducts?.map((product, index) => (

                            <div
                                className="col-xl-3 col-lg-4 col-md-6 col-sm-6"
                                key={index}
                            >

                                <div className="related-product-card">

                                    {/* IMAGE */}

                                    <div className="related-product-image">

                                        <img
                                            src={getImagePath(
                                                product?.image ||
                                                product?.images?.[0]
                                            )}
                                            alt={product?.name}
                                        />

                                    </div>

                                    {/* CONTENT */}

                                    <div className="related-product-content">

                                        <h5>
                                            {product?.name}
                                        </h5>

                                        {/* RATING */}

                                        <div className="mb-3">

                                            {Array.from({ length: 5 }, (_, starIndex) => {

                                                const rating = product?.rating || 0;

                                                if (rating >= starIndex + 1) {

                                                    return (
                                                        <i
                                                            key={starIndex}
                                                            className="fa fa-star text-warning"
                                                        ></i>
                                                    );

                                                }
                                                else if (rating >= starIndex + 0.5) {

                                                    return (
                                                        <i
                                                            key={starIndex}
                                                            className="fa fa-star-half-alt text-warning"
                                                        ></i>
                                                    );

                                                }
                                                else {

                                                    return (
                                                        <i
                                                            key={starIndex}
                                                            className="fa fa-star-o text-warning"
                                                        ></i>
                                                    );

                                                }

                                            })}

                                        </div>
                                                                <div className="tour-content">

                                        <h4 className="tour-box_price price-label">
                            {product.price
                              ? `₹${product.price}`
                              : 'Price on Request'}
                          </h4>
                                         

                                          <div className="tour-action">
                            <span className='price-label'>
                              <i className="fa-light fa-clock"></i>
                              {product.day || '5 Days'}
                            </span>

                          <Link 
    to={`/service-details/${product?._id || product?.id}`}
    className="th-btn style"
>
    View Details
</Link>
                          </div>

                                        

                                    </div>
                                    </div>

                                </div>

                            </div>

                        ))}

                    </div>

                </div>

            </section>

            {/* POPUP */}

            {showPopup && (

                <div
                    className="image-popup-overlay"
                    onClick={() => setShowPopup(false)}
                >

                    <div
                        className="image-popup-content"
                        onClick={(e) => e.stopPropagation()}
                    >

                        {/* CLOSE */}

                        <button
                            className="popup-close-btn"
                            onClick={() => setShowPopup(false)}
                        >
                            ×
                        </button>

                        {/* MAIN POPUP IMAGE */}

                        <img
                            src={getImagePath(activeImage)}
                            alt="popup"
                            className="main-popup-image"
                        />

                        {/* POPUP GALLERY */}

                        <div className="popup-gallery">

                            {/* BANNER IMAGE */}

                            {servicePost?.image && (

                                <img
                                    src={getImagePath(servicePost.image)}
                                    alt="banner"
                                    className={`popup-gallery-image ${
                                        activeImage === servicePost.image
                                            ? 'active'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        setActiveImage(servicePost.image)
                                    }
                                />

                            )}

                            {/* OTHER IMAGES */}

                            {servicePost?.images?.map((img, index) => (

                                <img
                                    key={index}
                                    src={getImagePath(img)}
                                    alt="gallery"
                                    className={`popup-gallery-image ${
                                        activeImage === img ? 'active' : ''
                                    }`}
                                    onClick={() => setActiveImage(img)}
                                />

                            ))}

                        </div>

                    </div>

                </div>

            )}

        </>
    );
}

export default ServiceDetailsMain;